import React from 'react';
import { toast } from 'react-toastify';
import { LayoutPageGrid } from '../../../../ui/LayoutGrid';
import { Loading } from '../../../../ui/Loading';
import { usePremiumInfoQuery } from '../../../../schema';
import { EditPremiumAccessForm } from './EditPremiumAccessForm';

export const EditPremiumAccessPage = () => {
  const { data, loading, error } = usePremiumInfoQuery();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    toast.error('Ошибка загрузки информации о Premium-доступе');
    return null;
  }

  return (
    <LayoutPageGrid title="Редактирование Premium-доступа">
      <EditPremiumAccessForm data={data} />
    </LayoutPageGrid>
  );
};
